export { default as Cost } from './Cost'
export { default as CostPsihologiyaIsHigherEducation } from './CostPsihologiyaIsHigherEducation'
export { getCostData } from './fractals'
